import { CommonTResponse } from "@/types/common"
import { handleApiResponse, serverApi } from "@core/api/core"
import { syncServerTime } from "@shared/utils/serverTimeSync"

export interface KioskIntroImageInfo {
  fileName: string
  fileSize: number
  uploadedAt?: string | null
  downloadUrl?: string | null
}

export interface KioskIntroSettings {
  showClinicName: boolean
}

export interface ServerTokenInfoResponse {
  isToken: boolean
  isTrial: boolean
  isAvailable: boolean
  remainDays: number
  hasTokenHistory: boolean
  expirationDt?: string | null
  tokenVersion?: number | null
}

export interface ServerInfoResponse {
  serverVersion: string
  chartSwApprovalNumber?: string | null
  serverTime?: string
  tokenInfo: ServerTokenInfoResponse
}

export const getServerInfo = async (): Promise<ServerInfoResponse> => {
  const requestUrl = `/device/public/server/info/`
  const clientSendTime = Date.now()
  const response = await serverApi.get<CommonTResponse<ServerInfoResponse>>(requestUrl)
  const clientReceiveTime = Date.now()
  const result = handleApiResponse<ServerInfoResponse>(response)

  // 서버 시간 오프셋 동기화 (NTP-style)
  if (result.serverTime) {
    syncServerTime(clientSendTime, result.serverTime, clientReceiveTime)
  }

  return result
}

export const getPublicKioskIntroImages = async (): Promise<KioskIntroImageInfo[]> => {
  const response = await serverApi.get(`/device/public/kiosk/intro-images/`)
  return handleApiResponse<KioskIntroImageInfo[]>(response)
}

export const getPublicKioskIntroSettings = async (): Promise<KioskIntroSettings> => {
  const response = await serverApi.get(`/device/public/kiosk/intro-images/settings/`)
  return handleApiResponse<KioskIntroSettings>(response)
}

export const uploadKioskIntroImage = async (file: File): Promise<KioskIntroImageInfo> => {
  const formData = new FormData()
  formData.append("file", file)

  const response = await serverApi.post(`/device/kiosk/intro-images/upload/`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  })
  return handleApiResponse<KioskIntroImageInfo>(response)
}

export const deleteKioskIntroImage = async (fileName: string): Promise<{ fileName: string }> => {
  const response = await serverApi.delete(`/device/kiosk/intro-images/delete/?file=${encodeURIComponent(fileName)}`)
  return handleApiResponse<{ fileName: string }>(response)
}

export const saveKioskIntroSettings = async (settings: KioskIntroSettings): Promise<KioskIntroSettings> => {
  const response = await serverApi.post(`/device/kiosk/intro-images/settings/`, settings)
  return handleApiResponse<KioskIntroSettings>(response)
}

